module.exports = __webpack_public_path__ + "img/bg-error.e7b030ca.png";